import React, { useContext } from "react";
import "./reportPage.css";
import { Container } from "react-bootstrap";
import { ReportContext } from "../ReportView";
import ReportBox from "../../../components/ReportComponent/ReportBox";
import TopBar from "../../../components/TopBarComponent/Topbar";
import AlertComponent from "../../../components/AlertComponent/AlertBox";
const ReportPage = () => {
  const {
    filterCriteria,
    setFilterCriteria,
    showDropdownList,
    setShowDropdownList,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    reportFilterData,
    criteriaRequired,
    setCriteriaRequired,
    alert,
    setAlert,
    errorMessage,
    reportSpinnerStatus,
    fromTime,
    setFromTime,
    toTime,
    setToTime,
    visitorType,
    setVisitorType,
    visitorTypeList,
    statusCode,
    logout,
    onSubmitExtendedStay, // extended stay submit function
    extendedStayTime, // state that store 24 hours converted time
    currentPage, // page number
  } = useContext(ReportContext);

  return (
    <>
      <div>
        <TopBar />
        <div>
          <Container className="outerContainerReport">
            <ReportBox
              showDropdownList={showDropdownList}
              setShowDropdownList={setShowDropdownList}
              filterCriteria={filterCriteria}
              setFilterCriteria={setFilterCriteria}
              fromDate={fromDate}
              setFromDate={setFromDate}
              toDate={toDate}
              setToDate={setToDate}
              criteriaRequired={criteriaRequired}
              submitReport={() => {
                if (filterCriteria === "Select") {
                  setCriteriaRequired(true);
                }

                reportFilterData();
              }}
              spinnerStatus={reportSpinnerStatus}
              fromTime={fromTime}
              setFromTime={setFromTime}
              toTime={toTime}
              setToTime={setToTime}
              visitorType={visitorType}
              visitorTypeList={visitorTypeList}
              setVisitorType={setVisitorType}
              onHandleSubmit={() => {
                onSubmitExtendedStay(currentPage, extendedStayTime);
              }}
            />
          </Container>

          <AlertComponent
            show={alert}
            showModal={setAlert}
            alertMessage={errorMessage}
            handleSubmit={
              statusCode == 401
                ? () => logout()
                : () => {
                    setAlert(false);
                  }
            }
          />
        </div>
      </div>
    </>
  );
};

export default ReportPage;
